export { default } from './section-card';
